import { Component, OnInit } from '@angular/core';
import {Router} from "@angular/router";
import {UserService} from "../../services/user/user.service";
import { NgxSpinnerService } from "ngx-spinner";
import { VersionService } from '../../services/version.service';

enum Pages {
  Login,
  ForgotPassword,
  VerifyAccount,
  ResetPassword,
}

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})


export class LoginComponent implements OnInit {
  email:string='';
  password:string='';
  confirmPassword:string='';
  page:Pages = Pages.Login;
  allPages = Pages; // UX use this.
  userNotVerified:boolean = false;
  paramObj: any = {};
  verifyText: string = 'Verifying...';
  version: string;

  constructor(
    private router: Router,
    private userService: UserService,
    private spinner: NgxSpinnerService,
    private versionService: VersionService
  ) {
    this.version = this.versionService.getVersion();
    const pathHash = (window as any).pathHash;
    if(pathHash.indexOf('?')>0) {
      const parameters = pathHash.split('?').pop().split('&');
      parameters.forEach(param => {
        const split = param.split('=');
        if (split.length > 1) {
          this.paramObj[split[0]] = decodeURIComponent(split.slice(1).join('='));
        }
      });

      if(this.paramObj.page === 'resetPassword') {
        this.page = Pages.ResetPassword;
      } else if(this.paramObj.page === 'verifyAccount') {
        this.page = Pages.VerifyAccount;
        this.verifyAccount();
      }
    }
  }

  ngOnInit(): void {
    // Make sure there is no spinner running
    this.spinner.hide();
  }

  getEmailFromBase64(hash) {
    try{
      return JSON.parse(atob(hash)).email;
    } catch (err) {
      return '';
    } 
  }

  async verifyAccount() {
    try {
      this.spinner.show();
      let response = await this.userService.verifyAccount(this.paramObj.hash);
      this.spinner.hide();
      if (response.success){
        alert("Account verified");
        this.email = this.getEmailFromBase64(this.paramObj.hash);
        if (this.paramObj.app === 'true') {
          this.verifyText = 'Your account has been verified. Please log into the app.';
        } else {
          this.page = Pages.Login;
        }
      }
      else {
        alert("Request failed, please contact your administrator");
      }
    } catch (error:any) {
      this.spinner.hide();
      alert(error.message);
    }
  }

  async login()
  {
    try {
      this.spinner.show();
      let response = await this.userService.login(this.email,this.password);
      this.spinner.hide();
      localStorage.setItem('user', JSON.stringify(response.body));
      this.router.navigate(['/records']);
    } catch (error:any) {
      this.spinner.hide();
      if (error.reason === 'resetPassword') {
        this.page = Pages.ForgotPassword;
      } else if (error.reason === 'userNotVerified') {
        this.userNotVerified = true;
      }
      alert(error.message);
    }
  }

  async resetPassword() {
    if (this.password !== this.confirmPassword) {
      alert('Your passwords do not match.');
      return;
    }
    try {
      this.spinner.show();
      let response = await this.userService.resetPassword(this.password, this.paramObj.hash);
      this.spinner.hide();
      if (response.success){
        alert("Password update successful.");
        this.email = this.getEmailFromBase64(this.paramObj.hash);
        this.confirmPassword = '';
        this.page = Pages.Login;
      }
      else {
        alert("Request failed, please contact your administrator");
      }
    } catch (error:any) {
      this.spinner.hide();
      alert(error.message);
      this.password = '';
      this.confirmPassword = '';
      this.page = Pages.Login;
    }
  }

  async forgotPassword(){
    try {
      this.spinner.show();
      let response = await this.userService.forgotPassword(this.email);
      this.spinner.hide();
      if (response.success){
        alert("Request sent, please check your email");
        this.page = Pages.Login;
      }
      else {
        alert("Request failed, please contact your administrator");
      }
    } catch (error:any) {
      this.spinner.hide();
      alert(error.message);
    }
  }
}
